let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4TfUE")).then(() => parcelRequire('9A3Xd'));